export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_PATTERN = /^(?:\+91|0)?[6-9]\d{9}$/;

const normalizeValue = (value) => String(value || "").trim();

export const isValidEmail = (value) =>
  EMAIL_PATTERN.test(normalizeValue(value));

export const isValidPhoneNumber = (value) =>
  PHONE_PATTERN.test(normalizeValue(value));

export const normalizePhoneNumber = (value) =>
  normalizeValue(value).replace(/\D/g, "").slice(-10);

export const getEmailValidationError = (value) => {
  if (!normalizeValue(value)) {
    return "Please provide an email";
  }

  return isValidEmail(value) ? "" : "Please provide a valid email";
};

export const getPhoneValidationError = (value) => {
  if (!normalizeValue(value)) {
    return "Please provide a phone number";
  }

  return isValidPhoneNumber(value)
    ? ""
    : "Enter 10 digits, optionally prefixed with 0 or +91";
};
